import { useMemo } from "react";

import { ColumnSortState } from "../../stores/slices/columnSortSlice";
import {
  ColumnSortOptions,
  SortEntry,
  createColumnSortFunc,
} from "./createColumnSortFunc";
import { useColumnSortState } from "./useColumnSortState";

interface ColumnSortFuncHook {
  <Key extends keyof ColumnSortState>(
    table: Key,
    options: ColumnSortOptions
  ): (a: SortEntry, b: SortEntry) => number;
}

export const useColumnSortFunc: ColumnSortFuncHook = (
  table,
  { dateFields, emptyLastFields, numericFields }
) => {
  const sort = useColumnSortState(table);

  const func = useMemo(
    () =>
      createColumnSortFunc(sort, {
        dateFields,
        emptyLastFields,
        numericFields,
      }),
    [dateFields, emptyLastFields, numericFields, sort]
  );

  return func;
};
